import tinycolor from "tinycolor2";

import { Button, Props as ButtonProps } from "components/shared/library/Button";

import { useWhiteLabel } from "contexts/WhiteLabelContext";

import { InterviewStyle } from "apis/interviewStyle";

import { darkenColor, lightenColor } from "utils/colors";

import { black, white } from "constants/colors";

export const WhiteLabelButton = ({
  interviewStyle: previewInterviewStyle,
  ...props
}: ButtonProps & { interviewStyle?: InterviewStyle }) => {
  const whiteLabel = useWhiteLabel(false);
  const customStyle = previewInterviewStyle || whiteLabel?.interviewStyle;
  if (!customStyle) return <Button {...props} />;

  const accentColor = customStyle.accentColor;
  const contrastColor = tinycolor(accentColor).isLight() ? black : white;
  const hoverColor = darkenColor(accentColor);
  const disabledColor = lightenColor(accentColor);

  const customColor = {
    filled: {
      default: {
        text: contrastColor,
        background: accentColor,
        border: accentColor,
        outline: "transparent",
      },
      hover: {
        text: contrastColor,
        background: hoverColor,
        border: hoverColor,
        outline: "transparent",
      },
      focus: {
        text: contrastColor,
        background: hoverColor,
        border: hoverColor,
        outline: "#E1E1E1",
      },
      disabled: {
        text: contrastColor,
        background: disabledColor,
        border: disabledColor,
        outline: "transparent",
      },
    },
    ghost: {
      default: {
        text: accentColor,
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
      hover: {
        text: accentColor,
        background: disabledColor,
        border: disabledColor,
        outline: "transparent",
      },
      focus: {
        text: accentColor,
        background: disabledColor,
        border: disabledColor,
        outline: "#E1E1E1",
      },
      disabled: {
        text: "#A8A8A8",
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
    },
    link: {
      default: {
        text: accentColor,
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
      hover: {
        text: hoverColor,
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
      focus: {
        text: hoverColor,
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
      disabled: {
        text: disabledColor,
        background: "transparent",
        border: "transparent",
        outline: "transparent",
      },
    },
    outlined: {
      default: {
        text: accentColor,
        background: "transparent",
        border: accentColor,
        outline: "transparent",
      },
      hover: {
        text: accentColor,
        background: disabledColor,
        border: accentColor,
        outline: "transparent",
      },
      focus: {
        text: accentColor,
        background: disabledColor,
        border: accentColor,
        outline: "#E1E1E1",
      },
      disabled: {
        text: "#A8A8A8",
        background: "transparent",
        border: disabledColor,
        outline: "transparent",
      },
    },
  };
  return <Button {...props} customColorMatrix={customColor} />;
};
